import _slicedToArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray";
import config from '@buildablecore/src/config';
import safeStorage from '@Builder/utils/SafeStorage';
import { useRouter } from 'next/router';
import React, { useEffect } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";

function Index() {
  var _router$query, _router$query2;

  var router = useRouter();
  var redirectUrl = router === null || router === void 0 ? void 0 : (_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.redirect_url;
  var isLoggingOut = router === null || router === void 0 ? void 0 : (_router$query2 = router.query) === null || _router$query2 === void 0 ? void 0 : _router$query2.logout;

  function handleLogout() {
    var _this = this;

    return {
      removeSensitiveData: function removeSensitiveData() {
        var _Object$keys;

        var shouldDeletePrefixes = ['editor'];
        var prefixDelimeter = '-';
        (_Object$keys = Object.keys(localStorage)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.forEach(function (k) {
          var _k$split = k.split(prefixDelimeter),
              _k$split2 = _slicedToArray(_k$split, 1),
              prefix = _k$split2[0];

          if (shouldDeletePrefixes.includes(prefix)) {
            safeStorage.removeItem(k);
          }
        });
        return _this;
      },
      redirect: function redirect() {
        if (window) {
          var _ref;

          window.location.href = (_ref = redirectUrl) !== null && _ref !== void 0 ? _ref : config.welcomeUrl;
        }
      }
    };
  }

  useEffect(function () {
    if (isLoggingOut) {
      var handler = handleLogout();
      handler.removeSensitiveData();
      handler.redirect();
    }
  }, [isLoggingOut, redirectUrl]);
  return /*#__PURE__*/_jsx("p", {
    children: "Redirecting..."
  });
}

export default Index;